import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "product-select-header PingFangSC-Regular" }
const _hoisted_2 = { class: "product-select-count-inner" }
const _hoisted_3 = { class: "product-select-options" }
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = ["src"]

import { MATERIALS, MATERIAL, RPODUCT_ATTRIBUTE_TYPE } from '@/data/const'
import { getProductIcon } from '@/utils/image'
import { ref } from 'vue'
import { computed, onUnmounted, watch } from 'vue'
import MaterialFilter from './MaterialFilter.vue'
import useSelect from '@/hooks/use-select'
import CAmount from '../common/CAmount.vue'
import {
  ProductSelectVisibility,
  namedImages,
  useCameraFrameStore,
  useConfAndQueryStore,
  useLayoutStore,
  useSeriesStore
} from '@/store'
import { storeToRefs } from 'pinia'
import { debounce, delay } from '@/utils'
import useScreen from '@/hooks/use-screen'
import { ClickAction } from '@/data/report'
import { isHonor, isHuawei, isHuaweiNote, isIOS } from '@/utils/device'
import useAlert from '@/hooks/use-alert'

// eslint-disable-next-line no-undef
const scrollTimeout = 180

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductSelect',
  props: {
  visibility: {
    type: String as () => ProductSelectVisibility,
    default: 'idle'
  },
  materialFilterVisibility: String as () =>
    | 'collapsed'
    | 'to-expand'
    | 'expanding'
    | 'expanded'
    | 'collapsing'
},
  emits: ['update:materialFilterVisibility'],
  setup(__props, { emit: __emit }) {

const emit = __emit
// eslint-disable-next-line no-undef
const props = __props

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { screenWidth, rootScale } = useScreen()
const scroller = ref()
const layoutStore = useLayoutStore()
const seriesStore = useSeriesStore()
const { hasAlertShown } = useAlert()
const {
  isSeriesEntryChanged,
  hasPendingSelectedSerieProduct,
  selectedSerialProduct
} = storeToRefs(seriesStore)
const { isSerieSelected, selectableProducts, selectedId, selectProduct } =
  useSelect()

const cameraFrameStore = useCameraFrameStore()
const { report } = useConfAndQueryStore()

const isScrollByScript = ref(false)
const isFilterVisible = ref(false)
const scrollTimeoutRef = ref()
const selectedMaterial = ref('')

const loading = ref(false)
const loadingTimer = ref<number>()

const disabled = ref(false)
const isWorkspaceHidden = computed(
  () => !layoutStore.isAllWorksReady || hasAlertShown.value
)
watch(isWorkspaceHidden, () => {
  if (isWorkspaceHidden.value) {
    disabled.value = true
  } else {
    delay(600).then(() => {
      disabled.value = false
    })
  }
})

const productsStyle = computed(() => {
  const itemSizeDesigned = 50,
    itemGapDesigned = 15
  const itemSizeRounded = Math.round(itemSizeDesigned * rootScale.value)
  const itemGapRounded = Math.round(itemGapDesigned * rootScale.value)

  return {
    '--list-gap': `${itemGapRounded}px`,
    '--list-padding': `calc(50% - calc(${itemSizeRounded}px / 2))`,
    '--list-item-size': `${itemSizeRounded}px`,
    '--list-item-space': itemSizeRounded + itemGapRounded
  }
})

const isSelectorHidden = computed(() => props.visibility === 'materials')
const isFilterHidden = computed(() => {
  if (props.visibility === 'materials') {
    switch (props.materialFilterVisibility) {
      case 'expanding':
      case 'expanded':
      case 'collapsing':
        return false
    }
  }
  return true
})
const isFilterContentHidden = computed(() => {
  if (props.visibility === 'materials') {
    switch (props.materialFilterVisibility) {
      case 'expanding':
      case 'expanded':
        return false
    }
  }
  return true
})

const materials = computed(() => {
  const materials = [] as MATERIAL[]
  selectableProducts.value.forEach(product => {
    product.attributes?.forEach(attr => {
      if (
        attr.type === RPODUCT_ATTRIBUTE_TYPE.MATERIAL &&
        !materials.find(mat => mat.label === attr.label)
      ) {
        const material = MATERIALS.find(mat => mat.label === attr.label)
        if (material) {
          materials.push(material)
        }
      }
    })
  })
  return materials.filter(material => !material.hidden)
})

const filteredProducts = computed(() => {
  if (selectedMaterial.value) {
    return selectableProducts.value.filter(
      product =>
        !product.hidden &&
        product.attributes
          ?.map(attr => attr.label)
          .includes(selectedMaterial.value)
    )
  }
  return selectableProducts.value.filter(product => !product.hidden)
})

const showFilter = async () => {
  if (props.materialFilterVisibility === 'collapsed') {
    emit('update:materialFilterVisibility', 'to-expand')
    await delay(400)
    isFilterVisible.value = true
    emit('update:materialFilterVisibility', 'expanding')
    await delay(600)
    emit('update:materialFilterVisibility', 'expanded')
  }
}

const hideFilter = async () => {
  if (props.materialFilterVisibility === 'expanded') {
    isFilterVisible.value = false
    emit('update:materialFilterVisibility', 'collapsing')
    await delay(600)
    emit('update:materialFilterVisibility', 'collapsed')
  }
}

const switchMaterialFilterVisibility = debounce(() => {
  report(ClickAction.FILTER)
  if (isFilterVisible.value) {
    hideFilter()
  } else {
    showFilter()
  }
})

const selectMaterial = (label: string) => {
  setTimeout(() => {
    selectedMaterial.value = label
    hideFilter()
  }, 210)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const indexOf = (el: HTMLElement, checkOnly = false) => {
  let result = -1
  if (el) {
    ;[...el.children[0].children].some(function (eleList, index) {
      if (filteredProducts.value[index]) {
        const left = eleList?.getBoundingClientRect().left
        // if (!checkOnly) {
        //   console.log('[[ Selection ] Position Of Product ]', {
        //     index,
        //     left,
        //     screen: screenWidth.value,
        //     space: productsStyle.value['--list-item-space']
        //   })
        // }
        if (
          left < window.innerWidth / 2.0 &&
          left >
            (window.innerWidth - productsStyle.value['--list-item-space']) / 2.0
        ) {
          result = index
          return true
        } else {
          return false
        }
      } else {
        console.error('[[ Selection ] 元素不在序列 ]', index)
      }
    })
  }
  return result
}

const scrollToSelectedElementByIndex = async (
  index: number,
  instant = false
) => {
  await delay(0)
  const currentIndex = indexOf(scroller.value, true)
  if (index === currentIndex) {
    // console.log(
    //   '[[ Selection ] No Need To Scroll ]',
    //   { index, instant },
    //   Date.now()
    // )
    isScrollByScript.value = false
  } else {
    isScrollByScript.value = true
    console.log(
      '[[ Selection ] Scroll To Index ]',
      { index, currentIndex, instant },
      Date.now()
    )
    scroller.value?.scrollTo({
      left: productsStyle.value['--list-item-space'] * index,
      behavior: instant ? 'instant' : 'smooth'
    })
  }
}

const onProductSelected = debounce((product, index: number) => {
  if (disabled.value) {
    console.log('不可点击')
    return
  }
  console.log(
    '[[ Selection ] Select Product / click product ]',
    { index, skuId: product.skuId },
    Date.now()
  )

  report(ClickAction.SCROLL_TO_PRODUCT, product.skuId)
  report(ClickAction.SELECT_PRODUCT, product.skuId)
  selectProduct(product)
  scrollToSelectedElementByIndex(index)
})

const onScroll = async () => {
  if ('onscrollend' in window) return
  console.log('看看这几处  222222')
  // 兼容不支持 scrollend 事件的浏览器
  // console.log('[[ Selection ] On Scroll ]')
  clearTimeout(scrollTimeoutRef.value)
  scrollTimeoutRef.value = setTimeout(() => {
    onScrollEnd()
  }, scrollTimeout)
}

const onScrollEnd = () => {
  console.log(
    '看看这几处  333333',
    isScrollByScript.value,
    hasPendingSelectedSerieProduct.value
  )
  if (isScrollByScript.value) {
    isScrollByScript.value = false
    return
  }
  if (hasPendingSelectedSerieProduct.value) return
  const index = indexOf(scroller.value)
  if (filteredProducts.value[index]) {
    console.log(
      '[[ Selection ] Select Product / scroll to product ]',
      { index, skuId: filteredProducts.value[index].skuId },
      Date.now()
    )
    if (selectProduct(filteredProducts.value[index])) {
      report(ClickAction.SCROLL_TO_PRODUCT, filteredProducts.value[index].skuId)
    }
  }
}

const reset = async (index: number, instant = true) => {
  const i = filteredProducts.value.length > index && index > -1 ? index : 0
  if (filteredProducts.value.length > 0) {
    const item = filteredProducts.value[i]
    selectProduct(item)
  }
  scrollToSelectedElementByIndex(i, instant)
}

watch(
  () => cameraFrameStore.isSkuLoading,
  async isLoading => {
    clearTimeout(loadingTimer.value)
    if (isLoading) {
      loadingTimer.value = setTimeout(() => {
        loading.value = true
      }, 300)
    } else {
      loading.value = false
    }
  }
)
watch(
  () => layoutStore.isAllWorksMode,
  () => {
    isFilterVisible.value = false
    emit('update:materialFilterVisibility', 'collapsed')
  }
)

watch(selectableProducts, () => {
  selectedMaterial.value = ''
  isFilterVisible.value = false
  emit('update:materialFilterVisibility', 'collapsed')
})

const fixSelectedProduct = debounce(async () => {
  let index = 0
  let instant = true

  if (hasPendingSelectedSerieProduct.value) {
    hasPendingSelectedSerieProduct.value = false
    await delay(0)
    index = filteredProducts.value.findIndex(
      p => p.skuId === selectedSerialProduct.value?.skuId
    )
    instant = isSeriesEntryChanged.value
    await delay(500)
  } else {
    const currentIndex = filteredProducts.value.findIndex(
      p => p.skuId === selectedId.value
    )
    console.log('selectedId', selectedId.value, currentIndex)
    if (currentIndex > -1) {
      index = currentIndex
    }
  }
  console.log('看看这几处  111111', { index, instant })
  reset(index, instant)
})
watch(
  [hasPendingSelectedSerieProduct, filteredProducts],
  (states, old) => {
    console.log('看看这几处  000000', states, old)
    if (old[0] && !states[0]) return
    isScrollByScript.value = true
    fixSelectedProduct()
  },
  { immediate: true }
)

onUnmounted(() => {
  clearTimeout(scrollTimeoutRef.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["product-select", [
      __props.visibility,
      __props.materialFilterVisibility,
      _unref(layoutStore).isShownByClosingSnapLayer ? 'closing-snap-layer' : undefined,
      _unref(isIOS) ? 'is-ios' : undefined
    ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["product-select-count flex-center", {
          'is-ios': _unref(isIOS),
          'is-huawei': _unref(isHuawei),
          'is-honor': _unref(isHonor),
          'is-huawei-note': _unref(isHuaweiNote)
        }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(CAmount, {
              value: filteredProducts.value.length
            }, null, 8, ["value"]),
            _createTextVNode(_toDisplayString(_unref(isSerieSelected) ? '种材质' : '件作品'), 1)
          ])
        ], 2),
        (materials.value.length > 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product-select-filter font-14 lh-24",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(switchMaterialFilterVisibility) && _unref(switchMaterialFilterVisibility)(...args)))
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "筛选条件", -1)),
              _createElementVNode("div", {
                class: _normalizeClass({
            'filtered-mark': true,
            filtered: selectedMaterial.value !== ''
          })
              }, null, 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["product-select-toolbar", { hidden: isSelectorHidden.value }]),
        style: _normalizeStyle(productsStyle.value)
      }, [
        _createElementVNode("div", {
          class: "product-select-scroller",
          ref_key: "scroller",
          ref: scroller,
          onScroll: onScroll,
          onScrollend: onScrollEnd
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.skuId,
                class: _normalizeClass(["product-select-option flex-center", [_unref(selectedId) + 'a1', product.skuId + 'b']])
              }, [
                ('materialIcon' in product)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: product.materialIcon,
                      class: _normalizeClass({ disabled: disabled.value }),
                      onClick: ($event: any) => (_unref(onProductSelected)(product, index))
                    }, null, 10, _hoisted_4))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      style: {"background":"#fff"},
                      src: _unref(getProductIcon)(product),
                      class: _normalizeClass({ disabled: disabled.value }),
                      onClick: ($event: any) => (_unref(onProductSelected)(product, index))
                    }, null, 10, _hoisted_5))
              ], 2))
            }), 128))
          ])
        ], 544),
        _createElementVNode("div", {
          class: _normalizeClass(["product-select-indicator flex-center", {
          loading: _unref(cameraFrameStore).isSkuLoading
        }])
        }, [
          _createElementVNode("img", {
            class: "icon-border-radius",
            src: _unref(namedImages).icon_product_indicator
          }, null, 8, _hoisted_6)
        ], 2)
      ], 6)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["material-filter-wrapper", { hidden: isFilterHidden.value }])
    }, [
      _createVNode(MaterialFilter, {
        visible: isFilterVisible.value,
        "content-hidden": isFilterContentHidden.value,
        products: _unref(selectableProducts),
        materials: materials.value,
        onSelect: selectMaterial,
        onRequestHide: hideFilter
      }, null, 8, ["visible", "content-hidden", "products", "materials"])
    ], 2)
  ], 64))
}
}

})